import { Text } from '@/design-system'

const ERROR_MAP: Record<string, string> = {
  form_password_incorrect: 'Incorrect password',
  form_identifier_not_found: 'No account found with that email',
  email_address_exists: 'An account with that email already exists',
  form_code_incorrect: 'That code is incorrect — try again',
  form_code_expired: 'Code expired — click Resend to get a new one',
  too_many_requests: 'Too many attempts. Please wait a moment',
  disposable_email: "Please use a permanent email address — disposable inboxes aren't allowed"
}

export function mapClerkError(code: string): string {
  return ERROR_MAP[code] ?? 'Something went wrong — please try again'
}

interface AuthErrorMessageProps {
  code: string
  className?: string
}

export function AuthErrorMessage({ code, className }: AuthErrorMessageProps) {
  return (
    <Text
      as="p"
      variant="mono-sm"
      weight={700}
      color="paper"
      className={className}
      style={{
        margin: '6px 0 0',
        padding: '4px 8px',
        background: 'var(--hot)',
        border: 'var(--border-thin) solid var(--ink)',
        display: 'inline-block'
      }}>
      {mapClerkError(code)}
    </Text>
  )
}
